
import React from "react";

const Project = () => {
    return (
        <div className="bg-[#add3f7] bg-cover bg-center w-full h-full flex flex-col  overflow-y-auto overflow-x-hidden">
            <div className="py-8  md:py-32 grid grid-row-2 w-full md:grid-cols-2 gap-8 px-6 md:px-16 ">
                {/* Project 1 */}
                <div>
                    <div className="flex flex-col">
                        <img alt="" className="md:w-0 md:h-0 place-self-center w-16 h-16 z-20 rounded-full" src="\assests\Project_1.png"></img>
                    </div>
                    <div className=" self-center flex w-full md:mt-0 mt-[-0.7rem] bg-gray-50 p-5 z-0  flex-col rounded-md shadow-md">
                        <div className=" grid md:grid-flow-col grid-flow-row md:gap-0 gap-1">
                            <div className="flex md:flex-row flex-col  md:gap-4 gap-1">
                                <h1 className="md:text-3xl text-2xl text-center font-[acme] text-black ">Smart Harvest</h1>
                            </div>

                            <img alt="" className="md:w-11 md:h-11 w-0 h-0 rounded-full place-self-end" src="\assests\Project_1.png"></img>

                        </div>

                        <ul className=" mt-2 items-start self-start ">
                            <li className="text-[14px] text-black text-justify md:text-left mt-1 ">● Developed an innovative Agriculture Application for Crop Prediction and Crop Disease Detection</li>
                            <li className="text-[14px] text-black text-justify md:text-left mt-1">● Implemented the Multi-language(English, Hindi, Marathi) support for a seamless user experience.</li>
                            <li className="text-[14px] text-black text-justify md:text-left mt-1">● Created a community platform for farmers to share knowledge and support each other.
                            </li>
                            <li className="text-[14px] text-black text-justify md:text-left mt-1">● Integrated AI-Chatbot for advanced features and intelligent decision-making.

                            </li>
                        </ul>
                        <div className="flex flex-row flex-wrap items-center gap-3 mt-4">
                            <div className="md:px-5 text-sm px-3 py-1 text-justify text-white font-Courier-New rounded bg-[#003a76]">Android SDK</div>
                            <div className="md:px-5 px-3 text-sm py-1 text-justify text-white font-Courier-New rounded bg-[#003a76]">Kotlin</div>
                            <div className="md:px-5 px-3 text-sm py-1 text-justify text-white font-Courier-New rounded bg-[#003a76]">Node.js</div>
                            <div className="md:px-5 px-3 text-sm py-1 text-justify text-white font-Courier-New rounded bg-[#003a76]">Machine Learning</div>
                            <div className="md:px-5 px-3 text-sm py-1 text-justify text-white font-Courier-New rounded bg-[#003a76]">Python</div>

                        </div>
                    </div>
                </div>
                {/* Project 2 */}
                <div>
                    <div className="flex flex-col">
                        <ul className="flex flex-row gap-4 z-20 place-self-center">
                            <li><img alt="" className="md:w-0 md:h-0 rounded-full  h-16 place-self-center" src="\assests\Project_2_1.png"></img></li>
                            <li><img alt="" className="md:w-0 md:h-0 rounded-full  h-16 place-self-center " src="\assests\Project_2_2.png"></img></li>
                        </ul>

                    </div>
                    <div className=" self-center flex w-full bg-gray-50 p-5 z-0 md:mt-0 mt-[-12px]  flex-col rounded-md shadow-md">
                        <div className=" grid md:grid-flow-col grid-flow-row md:gap-0 gap-1">
                            <div className="flex md:flex-row flex-col md:gap-4 gap-1">
                                <h1 className="md:text-3xl text-2xl text-center font-[acme] text-black ">Quiz Master and Quiz Setter</h1>
                            </div>
                            <ul className="place-self-end flex flex-row gap-4 md:w-fit md:h-fit w-0 h-0">
                                <li><img alt="" className="w-11 h-11 rounded-full " src="\assests\Project_2_1.png"></img></li>
                                <li><img alt="" className="w-11 h-11 rounded-full" src="\assests\Project_2_2.png"></img></li>
                            </ul>

                        </div>

                        <ul className=" mt-2 items-start self-start ">
                            <li className="text-[14px] text-black text-justify md:text-left mt-1 ">● Designed and developed a Pair of two Android Applications where users can create the Quiz and attempt the Quiz.</li>
                            <li className="text-[14px] text-black text-justify md:text-left mt-1">● Utilized advanced programming techniques to ensure a user-friendly and intuitive interface.</li>
                            <li className="text-[14px] text-black text-justify md:text-left mt-1">● Integrated Firebase Authentication for login and Firebase Realtime database for storing of Quiz.
                            </li>

                        </ul>
                        <div className="flex flex-row flex-wrap items-center gap-3 mt-4">
                            <div className="md:px-5 px-3 text-sm py-1 text-justify text-white font-Courier-New rounded bg-[#003a76]">Android SDK</div>
                            <div className="md:px-5 px-3 text-sm py-1 text-justify text-white font-Courier-New rounded bg-[#003a76]">Kotlin</div>
                            <div className="md:px-5 px-3 text-sm py-1 text-justify text-white font-Courier-New rounded bg-[#003a76]">Firebase</div>
                            <div className="md:px-5 px-3 text-sm py-1 text-justify text-white font-Courier-New rounded bg-[#003a76]">Android Studio</div>
                            <div className="md:px-5 px-3 text-sm py-1 text-justify text-white font-Courier-New rounded bg-[#003a76]">XML</div>

                        </div>
                    </div>
                </div>
                {/* Project 3 */}
                <div>
                    <div className="flex flex-col">
                        <img alt="" className="md:w-0 md:h-0 place-self-center  h-16 z-20 rounded-full" src="\assests\Project_3.png"></img>
                    </div>
                    <div className=" self-center flex w-full bg-gray-50 p-5 z-0 md:mt-0 mt-[-12px]  flex-col rounded-md shadow-md">
                        <div className=" grid md:grid-flow-col grid-flow-row md:gap-0 gap-1">
                            <div className="flex md:flex-row flex-col md:gap-4 gap-1">
                                <h1 className="md:text-3xl text-2xl text-center font-[acme] text-black ">Step Counter</h1>
                            </div>

                            <img alt="" className="md:w-11 md:h-11 w-0 h-0 rounded-full place-self-end" src="\assests\Project_3.png"></img>

                        </div>

                        <ul className=" mt-2 items-start self-start ">
                            <li className="text-[14px] text-black text-justify md:text-left mt-1 ">● Designed and created a user-friendly interface to enable easy monitoring of step count.</li>
                            <li className="text-[14px] text-black text-justify md:text-left mt-1">● Implemented Android Local Storage for efficient storage and retrieval of step count data, enabling personalized tracking.</li>

                        </ul>
                        <div className="flex flex-row flex-wrap items-center gap-3 mt-4">
                            <div className="md:px-5 px-3 text-sm py-1 text-justify text-white font-Courier-New rounded bg-[#003a76]">Android SDK</div>
                            <div className="md:px-5 px-3 text-sm py-1 text-justify text-white font-Courier-New rounded bg-[#003a76]">Kotlin</div>
                            <div className="md:px-5 px-3 text-sm py-1 text-justify text-white font-Courier-New rounded bg-[#003a76]">Mobile Sensors</div>
                            <div className="md:px-5 px-3 text-sm py-1 text-justify text-white font-Courier-New rounded bg-[#003a76]">Android Studio</div>
                            <div className="md:px-5 px-3 text-sm py-1 text-justify text-white font-Courier-New rounded bg-[#003a76]">XML</div>

                        </div>
                    </div>
                </div>
                {/* Project 4 */}
                <div>
                    <div className="flex flex-col">
                        <img alt="" className="md:w-0 md:h-0 place-self-center  h-16 z-20 rounded-full" src="\assests\Project_4.png"></img>
                    </div>
                    <div className=" self-center flex w-full bg-gray-50 p-5 z-0 md:mt-0 mt-[-12px]  flex-col rounded-md shadow-md">
                        <div className=" grid md:grid-flow-col grid-flow-row md:gap-0 gap-1">
                            <div className="flex md:flex-row flex-col md:gap-4 gap-1">
                                <h1 className="md:text-3xl text-2xl text-center font-[acme] text-black ">Android Tic-Tac-Toe</h1>
                            </div>

                            <img alt="" className="md:w-11 w-0 h-0 md:h-11 rounded-full place-self-end" src="\assests\Project_4.png"></img>

                        </div>

                        <ul className=" mt-2 items-start self-start ">
                            <li className="text-[14px] text-black text-justify md:text-left mt-1 ">● Developed Android Game Application for the Entertainment purpose.It offers Single and Multi-Player Mode for Playing.
                            </li>

                            <li className="text-[14px] text-black text-justify md:text-left mt-1">● Implemented Android Animations for interactive User Interface
                            </li>


                        </ul>
                        <div className="flex flex-row flex-wrap items-center gap-3 mt-4">
                            <div className="md:px-5 px-3 text-sm py-1 text-justify text-white font-Courier-New rounded bg-[#003a76]">Android SDK</div>
                            <div className="md:px-5 px-3 text-sm py-1 text-justify text-white font-Courier-New rounded bg-[#003a76]">Java</div>
                            <div className="md:px-5 px-3 text-sm py-1 text-justify text-white font-Courier-New rounded bg-[#003a76]">Android-Animations</div>
                            <div className="md:px-5 px-3 text-sm py-1 text-justify text-white font-Courier-New rounded bg-[#003a76]">Android Studio</div>
                            <div className="md:px-5 px-3 text-sm py-1 text-justify text-white font-Courier-New rounded bg-[#003a76]">XML</div>

                        </div>
                    </div>
                </div>
                {/* Project 5 */}
                <div>
                    <div className="flex flex-col">
                        <img alt="" className="md:w-0 md:h-0 place-self-center  h-16 z-20 rounded-full" src="\assests\Project_5.png"></img>
                    </div>
                    <div className=" self-center flex w-full bg-gray-50 p-5 z-0 md:mt-0 mt-[-12px]  flex-col rounded-md shadow-md">
                        <div className=" grid md:grid-flow-col grid-flow-row md:gap-0 gap-1">
                            <div className="flex md:flex-row flex-col md:gap-4 gap-1">
                                <h1 className="md:text-3xl text-2xl text-center font-[acme] text-black ">Space Shooter</h1>
                            </div>

                            <img alt="" className="md:w-11 md:h-11 w-0 h-0 rounded-full place-self-end" src="\assests\Project_5.png"></img>

                        </div>

                        <ul className=" mt-2 items-start self-start ">
                            <li className="text-[14px] text-black text-justify md:text-left mt-1 ">● Developed Desktop Game for Entertainment purpose.</li>

                        </ul>
                        <div className="flex flex-row flex-wrap items-center gap-3 mt-4">
                            <div className="md:px-5 px-3 text-sm py-1 text-justify text-white font-Courier-New rounded bg-[#003a76]">Python</div>
                            <div className="md:px-5 px-3 text-sm py-1 text-justify text-white font-Courier-New rounded bg-[#003a76]">Pygame</div>
                            <div className="md:px-5 px-3 text-sm py-1 text-justify text-white font-Courier-New rounded bg-[#003a76]">Desktop-Application development</div>

                        </div>
                    </div>
                </div>
                {/* Project 6 */}
                <div>
                    <div className="flex flex-col">
                        <img alt="" className="md:w-0 md:h-0 place-self-center  h-16 z-20 rounded-full" src="\assests\Project_6.png"></img>
                    </div>
                    <div className=" self-center flex w-full bg-gray-50 p-5 z-0 md:mt-0 mt-[-12px]  flex-col rounded-md shadow-md">
                        <div className=" grid md:grid-flow-col grid-flow-row md:gap-0 gap-1">
                            <div className="flex md:flex-row flex-col md:gap-4 gap-1">
                                <h1 className="md:text-3xl text-2xl text-center font-[acme] text-black ">Personal Portfolio</h1>
                            </div>
                            <img alt="" className="md:w-11 md:h-11 w-0 h-0 rounded-full place-self-end" src="\assests\Project_6.png"></img>

                        </div>

                        <ul className=" mt-2 items-start self-start ">
                            <li className="text-[14px] text-black text-justify md:text-left mt-1 ">● Designed and developed a Responsive Personal Portfolio Website.</li>


                        </ul>
                        <div className="flex flex-row flex-wrap items-center gap-3 mt-4">
                            <div className="md:px-5 px-3 text-sm py-1 text-justify text-white font-Courier-New rounded bg-[#003a76]">React.js</div>
                            <div className="md:px-5 px-3 text-sm py-1 text-justify text-white font-Courier-New rounded bg-[#003a76]">TailwindCss</div>
                            <div className="md:px-5 px-3 text-sm py-1 text-justify text-white font-Courier-New rounded bg-[#003a76]">JavaScript</div>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Project;